import React from 'react'
import styled from 'styled-components'
import { space, layout } from 'styled-system'
import { TEL_NUMBER, LINKS, COLORS } from 'config/constants'
import { Box, Grid, Flex } from 'components/atoms/Layout'
import { pxToRem } from 'utils/helpers'
import logo from 'assets/svg/logo-full-white-text.svg'
import chText from 'assets/images/ch_text.svg'
import chLogo from 'assets/images/ch_logo.svg'
import Link from 'components/atoms/Link'
import { Text } from 'components/atoms/Typography'
import Container from 'components/atoms/Container'
import SocialIconsLinks from './SocialIconsLinks'

const StyledLink = styled(Link).attrs(() => ({
  color: 'white',
  fontSize: 's',
  display: 'block',
}))``

const Title = styled(Text).attrs(() => ({
  fontSize: 's',
  fontWeight: 'bold',
  color: 'white',
  mb: 'm',
}))``

const Image = styled.img`
  display: block;
  ${space}
  ${layout}
`

const Footer = () => (
  <Box pt="xl" pb="xxl" backgroundColor={COLORS.INCREMENTAL_BLUE}>
    <Container>
      <Grid
        gridTemplateColumns={`repeat(
          auto-fit,
          minmax(${pxToRem(250)}, 1fr)
        )`}
        gridRowGap="xl"
        gridColumnGap={{ mobile: 'xl', tablet: 'xxl' }}
      >
        <Box data-aos="fade-up">
          <Text.Block gutter="m">
            <Image width="150px" src={logo} />
            <Text color="white" fontSize="s">
              NUNU is owned and operated by
            </Text>
            <Flex>
              <Link href={LINKS.CRESCENT_HEIGHTS_HOME}>
                <Grid
                  gridGap="10px"
                  gridAutoFlow="column"
                  alignItems="center"
                  minWidth={pxToRem(20)}
                >
                  <Image width="20px" src={chLogo} />
                  <Image width="150px" src={chText} />
                </Grid>
              </Link>
            </Flex>
          </Text.Block>
        </Box>
        <Box data-aos="fade-up">
          <Title>Contact us</Title>
          <Text.Block gutter="s">
            <Text color="white" fontSize="s">
              2200 Biscayne Boulevard
            </Text>
            <Text color="white" fontSize="s">
              Miami, FL 33137
            </Text>
            <Text color="white" fontSize="s">
              Email: hi@hinunu.com
            </Text>
            <StyledLink href={`tel:${TEL_NUMBER}`}>
              {`tel: ${TEL_NUMBER}`}
            </StyledLink>
          </Text.Block>
        </Box>
        <Box data-aos="fade-up">
          <Title>Social media</Title>
          <Text.Block gutter="s">
            <SocialIconsLinks />
            <StyledLink href="/privacy_policy.pdf">Privacy policy</StyledLink>
            <StyledLink href={LINKS.CRESCENT_HEIGHTS_PRESS}>Press</StyledLink>
          </Text.Block>
        </Box>
      </Grid>
    </Container>
  </Box>
)

export default Footer
